const SUBMISSIONS_KEY = "submissions";

function initializeSubmissions() {
  if (!localStorage.getItem(SUBMISSIONS_KEY)) {
    localStorage.setItem(SUBMISSIONS_KEY, JSON.stringify([]));
  }
}

export function getAllSubmissions() {
  initializeSubmissions();
  return JSON.parse(localStorage.getItem(SUBMISSIONS_KEY));
}

export function addSubmission({ title, synopsis, genres, submittedBy }) {
  initializeSubmissions();
  const submissions = JSON.parse(localStorage.getItem(SUBMISSIONS_KEY));
  const newPitch = {
    id: Date.now().toString(),
    title: title.trim(),
    synopsis: synopsis.trim(),
    genres: Array.isArray(genres) ? genres : [genres],
    submittedBy,
    submittedAt: new Date().toISOString(),
    status: "pending",
    comments: "",
  };
  submissions.push(newPitch);
  localStorage.setItem(SUBMISSIONS_KEY, JSON.stringify(submissions));
  return newPitch;
}

export function updateSubmission(id, { status, comments }) {
  initializeSubmissions();
  const submissions = JSON.parse(localStorage.getItem(SUBMISSIONS_KEY));
  const idx = submissions.findIndex((s) => s.id === id);
  if (idx === -1) return null;
  if (status) submissions[idx].status = status;
  if (typeof comments === "string") submissions[idx].comments = comments;
  localStorage.setItem(SUBMISSIONS_KEY, JSON.stringify(submissions));
  return submissions[idx];
}

export function getSubmissionById(id) {
  initializeSubmissions();
  const submissions = JSON.parse(localStorage.getItem(SUBMISSIONS_KEY));
  return submissions.find((s) => s.id === id) || null;
}